export default class ExpertisesCard {
  init() {
    this.OpenCard();
  }

  OpenCard() {
    this.cards = document.querySelectorAll('.card-expertises');

    if (!this.cards.length) {
      return;
    }

    this.cards.forEach((card) => {
      if (card.classList.contains('card-expertises--without-dropdown')) {
        return;
      }

      const button = card.querySelector('.card-expertises__header-button');
      const footer = card.querySelector('.card-expertises__footer');
      const footerWrapper = card.querySelector(
        '.card-expertises__footer-wrapper'
      );

      button.addEventListener('click', () => {
        const open = !card.classList.contains('card-expertises--is-open');

        card.classList.toggle('card-expertises--is-open', open);

        if (open) {
          button.setAttribute('aria-expanded', true);
          footer.style.display = 'flex';

          requestAnimationFrame(() => {
            footer.style.height = `${footerWrapper.offsetHeight}px`;
          });
        } else {
          button.setAttribute('aria-expanded', false);
          footer.style.height = '0px';

          setTimeout(() => {
            footer.style.display = 'none';
          }, 300);
        }
      });
    });
  }
}
